import { useTranslation } from 'react-i18next';

import CustomBadge from '../../../../components/common/CustomBadge/CustomBadge';
import { getStatusBadge } from '../../../../components/ServiceAgreement/Common/ServiceAgreementRowHelper';
import { ServiceAgreementStatus } from '../../../../components/ServiceAgreement/Common/ServiceAgreementTypes';

export interface StatusBadgeCellProps {
  status: ServiceAgreementStatus;
}

/**
 * Status badge cell: `getStatusBadge` (existing colors/copy for
 * Active / Pending / Invited / Declined / Expired). Shared by all three
 * pages wherever a status column appears (Requests, and any future reuse).
 */
export default function StatusBadgeCell({ status }: StatusBadgeCellProps) {
  const { t } = useTranslation();
  const badge = getStatusBadge(status, t);
  return (
    <CustomBadge
      size="s"
      text={badge.text}
      backgroundColor={badge.bg}
      borderColor={badge.borderColor}
      textColor={badge.textColor}
    />
  );
}
